'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _multireducer = require('multireducer');

var _multireducer2 = _interopRequireDefault(_multireducer);

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _adminState = require('./adminState');

var _adminState2 = _interopRequireDefault(_adminState);

var _adminBarriers = require('./adminBarriers');

var _adminBarriers2 = _interopRequireDefault(_adminBarriers);

var _adminGoals = require('./adminGoals');

var _adminGoals2 = _interopRequireDefault(_adminGoals);

var _adminModuleApps = require('./adminModuleApps');

var _adminModuleApps2 = _interopRequireDefault(_adminModuleApps);

var _adminStrategies = require('./adminStrategies');

var _adminStrategies2 = _interopRequireDefault(_adminStrategies);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _counter = require('./counter');

var _counter2 = _interopRequireDefault(_counter);

var _reduxForm = require('redux-form');

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _modules = require('./modules');

var _modules2 = _interopRequireDefault(_modules);

var _moduleData = require('./moduleData');

var _moduleData2 = _interopRequireDefault(_moduleData);

var _recipes = require('./recipes');

var _recipes2 = _interopRequireDefault(_recipes);

var _resources = require('./resources');

var _resources2 = _interopRequireDefault(_resources);

var _profile = require('./profile');

var _profile2 = _interopRequireDefault(_profile);

var _goals = require('./goals');

var _goals2 = _interopRequireDefault(_goals);

var _userCredential = require('./userCredential');

var _userCredential2 = _interopRequireDefault(_userCredential);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGOUT_SUCCESS = 'redux-example/auth/LOGOUT_SUCCESS';

var appReducer = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  admin: _admin2.default,
  adminBarriers: _adminBarriers2.default,
  adminGoals: _adminGoals2.default,
  adminModuleApps: _adminModuleApps2.default,
  adminStrategies: _adminStrategies2.default,
  adminState: _adminState2.default,
  auth: _auth2.default,
  form: _reduxForm.reducer,
  goals: _goals2.default,
  modules: _modules2.default,
  moduleData: _moduleData2.default,
  multireducer: (0, _multireducer2.default)({
    counter1: _counter2.default,
    counter2: _counter2.default,
    counter3: _counter2.default
  }),
  info: _info2.default,
  profile: _profile2.default,
  recipes: _recipes2.default,
  resources: _resources2.default,
  userCredential: _userCredential2.default
});

/*eslint-disable*/
var rootReducer = function rootReducer(state, action) {
  if (action.type === LOGOUT_SUCCESS) {
    var _state = state,
        routing = _state.routing;

    state = { routing: routing };
    console.log("DOES THIS PLACE HIT?");
  }

  return appReducer(state, action);
};
/*eslint-enable*/

exports.default = rootReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1297
// module chunks = 0